import type { TIconProps } from "./types";

export const Message = (props: TIconProps) => {
  return (
    <svg
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.23404 0.71746C6.41137 0.711785 9.58866 0.71746 12.766 0.734481C14.2993 0.964946 15.3262 1.81033 15.8468 3.27065C15.9096 3.49414 15.9551 3.72107 15.983 3.9515C16.0057 6.16427 16.0057 8.37703 15.983 10.5898C15.7488 12.0834 14.9261 13.0991 13.5149 13.6366C13.2258 13.7239 12.9308 13.7807 12.6298 13.8068C11.1546 13.8181 9.67942 13.8295 8.20425 13.8409C6.80265 14.7629 5.40691 15.6934 4.01702 16.6323C3.53423 16.8308 3.17678 16.7004 2.94468 16.2409C2.89494 15.4029 2.87792 14.5632 2.89362 13.7217C1.24463 13.3151 0.285761 12.2712 0.0170221 10.5898C-0.00567404 8.37703 -0.00567404 6.16427 0.0170221 3.9515C0.247487 2.41818 1.09288 1.39123 2.55319 0.870652C2.78328 0.812265 3.01021 0.761201 3.23404 0.71746ZM3.60851 2.18129C6.5362 2.17561 9.46386 2.18129 12.3915 2.19831C13.2655 2.25577 13.9066 2.66996 14.3149 3.44086C14.4481 3.73247 14.5162 4.03885 14.5191 4.36001C14.5418 6.30044 14.5418 8.24086 14.5191 10.1813C14.461 11.1124 14.0128 11.7763 13.1745 12.1728C13.0085 12.2341 12.8383 12.2795 12.6638 12.3089C11.0169 12.3096 9.3715 12.3323 7.72766 12.377C6.61252 13.0962 5.50614 13.8282 4.40851 14.5728C4.39717 14.0281 4.3858 13.4834 4.37447 12.9387C4.3216 12.668 4.16841 12.4808 3.91489 12.377C2.83758 12.3759 2.07163 11.8936 1.61702 10.9302C1.52823 10.6885 1.48284 10.4389 1.48085 10.1813C1.45815 8.24086 1.45815 6.30044 1.48085 4.36001C1.61282 3.06497 2.32204 2.33873 3.60851 2.18129Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.43818 5.07476C6.47934 5.06908 9.52046 5.07476 12.5616 5.09179C12.9119 5.20729 13.0935 5.45124 13.1063 5.8237C13.0815 6.16239 12.9113 6.39504 12.5956 6.52157C9.5318 6.54428 6.46797 6.54428 3.40414 6.52157C2.9768 6.3292 2.82361 6.00579 2.94456 5.55136C3.039 5.315 3.20353 5.15613 3.43818 5.07476Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.97019 7.9685C6.99007 7.96282 9.00995 7.9685 11.0298 7.98552C11.5932 8.16489 11.769 8.53368 11.5574 9.09191C11.4374 9.29112 11.2615 9.41027 11.0298 9.44935C9.00992 9.47206 6.99004 9.47206 4.97019 9.44935C4.49625 9.31533 4.29768 9.00326 4.37445 8.51318C4.47185 8.21708 4.67042 8.0355 4.97019 7.9685Z"
        fill="currentColor"
      />
    </svg>
  );
};
